/**
 * Language Switcher Component - Toggle Style
 * 語言切換器組件 - 切換按鈕樣式
 */
import { useLanguage } from '../../../i18n/LanguageProvider';
import { trackLanguageChange } from '../../../utils/analytics';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { language, changeLanguage } = useLanguage();

  const handleToggle = () => {
    const previousLanguage = language;
    const newLanguage = language === 'en' ? 'zh-yue' : 'en';
    changeLanguage(newLanguage);
    trackLanguageChange(newLanguage, previousLanguage);
  };

  return (
    <div className="language-toggle-container">
      <button
        className="language-toggle"
        onClick={handleToggle}
        aria-label="Switch language"
      >
        <span className={`toggle-option ${language === 'en' ? 'active' : ''}`}>
          English
        </span>
        <span className={`toggle-option ${language === 'zh-yue' ? 'active' : ''}`}>
          繁體中文
        </span>
      </button>
    </div>
  );
}
